import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ProductImageGallery = ({ images, currentImage, onImageChange }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // 当currentImage改变时，更新currentIndex
  React.useEffect(() => {
    const index = images.findIndex(img => img === currentImage);
    if (index !== -1) {
      setCurrentIndex(index);
    }
  }, [currentImage, images]);

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(nextIndex);
    if (onImageChange && typeof onImageChange === 'function') {
      onImageChange(images[nextIndex]);
    }
  };

  const prevImage = () => {
    const prevIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(prevIndex);
    if (onImageChange && typeof onImageChange === 'function') {
      onImageChange(images[prevIndex]);
    }
  };

  const goToImage = (index) => {
    console.log('goToImage called with index:', index, 'image:', images[index]);
    setCurrentIndex(index);
    if (onImageChange && typeof onImageChange === 'function') {
      onImageChange(images[index]);
    }
  };

  if (!images || images.length === 0) return null;

  return (
    <div className="relative">
      {/* 主图显示 */}
      <div className="bg-gray-800 rounded-lg overflow-hidden mb-4 aspect-square relative">
        <img 
          src={images[currentIndex] || images[0]} 
          alt="Product" 
          className="w-full h-full object-cover object-center"
          onLoad={() => console.log('Main image loaded:', images[currentIndex] || images[0])}
        />
        {/* 水印 */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="text-white/20 text-6xl font-bold select-none">
            CHILL GAMING
          </div>
        </div>
      </div>
      
      {/* 图片画廊 */}
      <div className="relative">
        {/* 左箭头 - 只在有多个图片时显示 */}
        {images.length > 1 && (
          <button
            onClick={prevImage}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 z-50 bg-black/70 hover:bg-black/90 text-white p-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl"
            aria-label="Previous image"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}

        {/* 右箭头 - 只在有多个图片时显示 */}
        {images.length > 1 && (
          <button
            onClick={nextImage}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 z-50 bg-black/70 hover:bg-black/90 text-white p-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl"
            aria-label="Next image"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}

                 {/* 图片滚动容器 */}
         <div className="overflow-x-auto scrollbar-hide">
           <div className="flex gap-2 pb-2">
             {images.map((img, index) => (
               <motion.button
                 key={index}
                 onClick={() => goToImage(index)}
                 className={`bg-gray-800 rounded-md overflow-hidden border-2 w-20 h-20 flex-shrink-0 transition-all duration-200 relative ${
                   currentIndex === index 
                     ? 'border-green-500' 
                     : 'border-transparent hover:border-green-400'
                 }`}
                 whileTap={{ scale: 0.95 }}
               >
                 <img 
                   src={img} 
                   alt={`Product view ${index + 1}`} 
                   className="w-full h-full object-cover object-center"
                   onError={(e) => { 
                     e.target.src = '/images/products/placeholder.jpg'; 
                   }}
                 />
                 {/* 缩略图水印 */}
                 <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                   <div className="text-white/10 text-xs font-bold select-none">
                     CHILL GAMING
                   </div>
                 </div>
               </motion.button>
             ))}
           </div>
         </div>

        {/* 图片指示器 */}
        <div className="flex justify-center mt-2 space-x-1">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToImage(index)}
              className={`w-2 h-2 rounded-full transition-all duration-200 ${
                currentIndex === index ? 'bg-green-500' : 'bg-gray-600 hover:bg-gray-500'
              }`}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductImageGallery;
